var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var DefaultInvalidateCacheTime = 60000;
var DefaultMaxCacheLength = 100;
var CACHE = {};
function isParamsEmpty(params) {
    return Object.values(params).every(function (value) { return !value; });
}
function cleanCache() {
    var e_1, _a;
    try {
        for (var _b = __values(Object.getOwnPropertyNames(CACHE)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var prop = _c.value;
            delete CACHE[prop];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function createCacheKey(apiUrl, params) {
    var isNoParams = isParamsEmpty(params);
    var reqParams = isNoParams ? '' : "@" + JSON.stringify(params);
    return "" + apiUrl + reqParams;
}
function isNeedToFetch(cachedValue, invalidateCacheTime) {
    var isNeedRefetch = cachedValue && Date.now() - cachedValue.requestTime > invalidateCacheTime;
    return !cachedValue || isNeedRefetch;
}
export function cachedRequest(axiosGet, apiUrl, params, invalidateCacheTime, maxCacheLength) {
    if (invalidateCacheTime === void 0) { invalidateCacheTime = DefaultInvalidateCacheTime; }
    if (maxCacheLength === void 0) { maxCacheLength = DefaultMaxCacheLength; }
    return __awaiter(this, void 0, void 0, function () {
        var cacheLength, cacheKey, cachedValue, _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cacheLength = Object.keys(CACHE).length;
                    if (cacheLength >= maxCacheLength) {
                        cleanCache();
                    }
                    cacheKey = createCacheKey(apiUrl, params);
                    cachedValue = CACHE[cacheKey];
                    if (!isNeedToFetch(cachedValue, invalidateCacheTime)) return [3 /*break*/, 4];
                    CACHE[cacheKey] = { requestTime: Date.now() };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = CACHE[cacheKey];
                    return [4 /*yield*/, axiosGet(apiUrl, { params: params })];
                case 2:
                    _a.data = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, CACHE[cacheKey].data];
            }
        });
    });
}
//# sourceMappingURL=utils.js.map